// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionRecordIdentifier
 */
export interface IContributionRecordIdentifier {
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordIdentifier
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordIdentifier
     */
    record_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionRecordIdentifier
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionRecordIdentifier
     */
    tax_year?: number;
    /**
     * 
     * @type {Date}
     * @memberof IContributionRecordIdentifier
     */
    contribution_date?: Date;
}

/**
 * Check if a given object implements the IContributionRecordIdentifier interface.
 */
export function instanceOfIContributionRecordIdentifier(value: object): value is IContributionRecordIdentifier {
    return true;
}

export function IContributionRecordIdentifierFromJSON(json: any): IContributionRecordIdentifier {
    return IContributionRecordIdentifierFromJSONTyped(json, false);
}

export function IContributionRecordIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRecordIdentifier {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'record_id': json['record_id'] == null ? undefined : json['record_id'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'contribution_date': json['contribution_date'] == null ? undefined : (new Date(json['contribution_date'])),
    };
}

export function IContributionRecordIdentifierToJSON(json: any): IContributionRecordIdentifier {
    return IContributionRecordIdentifierToJSONTyped(json, false);
}

export function IContributionRecordIdentifierToJSONTyped(value?: IContributionRecordIdentifier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'record_id': value['record_id'],
        'plan_code': value['plan_code'],
        'tax_year': value['tax_year'],
        'contribution_date': value['contribution_date'] == null ? undefined : ((value['contribution_date']).toISOString().substring(0,10)),
    };
}

